import individualWorkSupportUtil from '../../../../../share/util/individualWorkSupportUtil';
import session from '../../../../../share/session';
import util from '../../../../../share/util/utils';
import { REQUEST_STATUS_COMPLETED, REQUEST_STATUS_FAILED } from '../../../../../share/util/api/polling';
import { terminate } from './terminate';
import { PHASE } from './constants';

/**
 * 履歴有無情報読み出し
 * @param {object} self this インスタンス
 */
export async function standby(self) {
  try {
    self.isLoading = true;
    const token = session.getToken();
    const response = await individualWorkSupportUtil.pollingWspApi(
      self,
      self.netAppId,
      self.systemId,
      self.workSupportId,
      {
        id_token: token.id_token,
        is_special: true,
        type: 'standby'
      },
      // エラー発生のコールバック
      async (errorType) => { errorType; await self.showUnexpectedError(); },
      // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
      async (result) => { await self.validateErrorResult(result); },
      // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
      async (result) => { await self.validateErrorResult(result); }
    );

    if (response) {
      switch (response.data.status) {
        case REQUEST_STATUS_COMPLETED:
          // 履歴有無情報が空の場合
          if (response.data.user_data.results.length === 0) {
            // 失敗表示画面に遷移
            await terminate(self, PHASE.FAILED);
          } else {
            setHistoryList(self, response.data.user_data.results);
            self.toSelectPhase();
          }
          break;
        case REQUEST_STATUS_FAILED:
        default:
          await self.showUnexpectedError();
          break;
      }
    }
  } finally {
    self.isLoading = false;
  }
}

/**
 * 履歴情報表示画面、プレビュー選択画面で表示する項目を作成
 * @param {object} self this インスタンス
 * @param {object} readData 履歴有無情報
 */
function setHistoryList(self, readData) {
  self.historyList = [];
  self.previewList = [];
  self.selectedPreviewItem = null;

  readData.forEach(item => {
    item.histories.forEach(history => {
      // ローカルタイムに変換
      history.date_time = convertLocalDateTime(history.date_time);
    });
    self.historyList.push({
      image_type: item.image_type,
      history_id: item.history_id,
      data_size: item.data_size,
      histories: item.histories,
      displayName: self.$t(`${self.i18nWsKey}.${item.image_type}`),
      selected: false
    });
    self.previewList.push({
      image_type: item.image_type,
      histories: item.histories,
      displayName: self.$t(`${self.i18nWsKey}.${item.image_type}`)
    });
  });

  // 「すべて選択」の項目を先頭に追加
  self.historyList.unshift({
    displayName: self.$t(`${self.i18nWsKey}.history_name_all`),
    selected: false,
    isAllSelect: true
  });
}

/**
 * GMTからLocalTimeへ変換
 * @param {string} responseDate 絶対時間タイプスタンプ情報 YYYY-MM-DDThh:mm:ssZ
 * @returns {string} ローカルタイム YYYY/MM/DD hh:mm:ss
 */
function convertLocalDateTime(responseDate) {
  if (!responseDate) {
    return null;
  }

  const globalDate = new Date(responseDate);

  // LocalTimeに変換
  return util.timeConverter(globalDate);
}